import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormsService } from '../forms.service';
import { CommonService } from '../../../../../../../../../../shared/services/common.service';
import { DailyReportService } from '../../../../daily-report.service';

@Component({
    selector: 'app-frequency-question-form',
    templateUrl: './frequency-question-form.component.html',
    styleUrls: ['./frequency-question-form.component.scss'],
    standalone: false
})
export class FrequencyQuestionFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() form: FormGroup = new FormGroup({});
  @Input() currentQuestion: any;
  @Input() frequency: any;
  @Input() currentIndex: any;
  selectedMediaFiles: any = [];
  displayCommentSection = false;
  frequencyQuestionsFrom: FormGroup = new FormGroup({});
  videoToBeDeletedFromMuxDb = [];
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private formsService: FormsService,
    private commonService: CommonService,
    private cdRef: ChangeDetectorRef,
    private dailyReportService: DailyReportService,
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentQuestion']) {
      this.displayCommentSection = false;
      this.selectedMediaFiles = [];
      this.frequencyQuestionsFrom = this.getFormGroup(this.form, this.currentQuestion?.id, this.frequency.name);

      const frequencyQuestionsFromFieldValue = this.frequencyQuestionsFrom.controls.field_values.value;

      if (this.currentIndex === 0 &&
        (frequencyQuestionsFromFieldValue === 'N/A' || frequencyQuestionsFromFieldValue === 'Yes' || frequencyQuestionsFromFieldValue === 'Pass')) {
        this.frequencyQuestionsFrom.addControl('applyToAll', new FormControl(), { emitEvent: false });
      }

      const tempPictureData = this.getPictures();
      const tempVideosData = this.getVideos();

      const allNewItems = [...tempPictureData, ...tempVideosData];

      allNewItems.forEach(item => {
        const existingItem = this.selectedMediaFiles.find(ei => ei.id === item.id);

        if (!existingItem) {
          this.selectedMediaFiles.push(item);
        }
      });

      this.cdRef.detectChanges();
    }
  }

  ngOnInit(): void {
    this.formsService.addComment
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.displayCommentSection = true;
      });

    this.frequencyQuestionsFrom?.controls?.['field_values']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.frequencyQuestionsFrom.removeControl('applyToAll', { emitEvent: false });

        if ((data === 'N/A' || data === 'Yes' || data === 'Pass') && this.currentIndex === 0) {
          this.frequencyQuestionsFrom.addControl('applyToAll', new FormControl(), { emitEvent: false });

          this.frequencyQuestionsFrom?.controls?.['applyToAll']?.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe((appliedToAll) => {
              if (appliedToAll) {
                this.setFieldValues(data, this.frequency.name);
              }
            });

        } else {
          this.frequencyQuestionsFrom.removeControl('applyToAll', { emitEvent: false });
        }
      });

    this.commonService.uploadedFilesInfoOnPopup
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        data = JSON.parse(JSON.stringify(data));
        const items = Array.isArray(data) ? data : [data];

        items.forEach(eachItem => {
          if (eachItem?.['fileType'] === 'picture' || eachItem?.['fileType'] === 'document') {
            let pictures = this.frequencyQuestionsFrom?.get('pictures')?.value || '[]';
            pictures = JSON.parse(pictures);
            pictures.push(eachItem);
            this.frequencyQuestionsFrom?.get('pictures')?.setValue(JSON.stringify(pictures));
          }

          if (eachItem?.['fileType'] === 'video') {
            let videos = this.frequencyQuestionsFrom?.get('videos')?.value || '[]';
            videos = JSON.parse(videos);
            videos.push(eachItem);
            this.frequencyQuestionsFrom?.get('videos')?.setValue(JSON.stringify(videos));
          }
        });

        const tempPictureData = this.getPictures() ?? [];
        const tempVideosData = this.getVideos() ?? [];
        const allNewItems = [...tempPictureData, ...tempVideosData];
        allNewItems.forEach(item => {
          const existingItem = this.selectedMediaFiles.find(ei => ei.id === item.id);

          if (!existingItem) {
            this.selectedMediaFiles.push(item);
          }
        });

        this.selectedMediaFiles = [...this.selectedMediaFiles];
      });

    this.form?.controls[`${this.frequency.name}_questions`].valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        const pass = [];
        const fail = [];
        const na = [];
        const answered = [];

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            if (data[key].field_values !== null) {
              answered.push(data[key]);
            }

            if (data[key].field_values === 'Pass' || data[key].field_values === 'Yes') {
              pass.push(data[key]);
            }
            if (data[key].field_values === 'Fail' || data[key].field_values === 'No') {
              fail.push(data[key]);
            }
            if (data[key].field_values === 'N/A') {
              na.push(data[key]);
            }
          }
        }

        this.dailyReportService.updateFrequencyQuestionValue.next({ value: { pass, fail, na, answered }, key: this.frequency.name });
      });
  }

  getFormGroup(form: FormGroup, controlName: string, frequencyName): any {
    if (form && form.get(`${frequencyName}_questions`) instanceof FormGroup) {
      const questions = form.get(`${frequencyName}_questions`) as FormGroup;

      for (const controlKey of Object.keys(questions.controls)) {
        if (controlKey.includes(`_${controlName}`)) {
          return questions.get(controlKey) as FormGroup;
        }
      }
    }
  }

  getPictures() {
    const pictures = this.frequencyQuestionsFrom?.get('pictures')?.value || '[]';
    return JSON.parse(pictures);
  }

  getVideos() {
    const videos = this.frequencyQuestionsFrom?.get('videos')?.value || '[]';
    return JSON.parse(videos);
  }


  deletePicture(pic) {
    if (pic.fileType === 'picture') {
      let pictures = this.getPictures();

      pictures = pictures?.filter(o => o.id !== pic.id);
      this.selectedMediaFiles = this.selectedMediaFiles?.filter(o => o.id !== pic.id);
      this.frequencyQuestionsFrom?.get('pictures')?.setValue(JSON.stringify(pictures));
    }

    if (pic.fileType === 'video') {
      let videos = this.getVideos();

      videos = videos?.filter(o => o.id !== pic.id);
      this.selectedMediaFiles = this.selectedMediaFiles?.filter(o => o.id !== pic.id);
      this.frequencyQuestionsFrom?.get('videos')?.setValue(JSON.stringify(videos));
      this.videoToBeDeletedFromMuxDb.push(pic.id);
    }
  }

  setFieldValues(value, frequencyName) {
    const questionsGroup = this.form.get(`${frequencyName}_questions`) as FormGroup;
    if (Object.keys(questionsGroup.controls).length > 0) {
      Object.keys(questionsGroup.controls).forEach(key => {
        const nestedGroup = questionsGroup.get(key) as FormGroup;
        if (nestedGroup && nestedGroup.get('field_values')) {
          nestedGroup?.get('field_values')?.setValue(value, { emitEvent: false });
        }
      });
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
